;(function($, window, document) {
    "use strict";

    const track = (funnelId, pageId, variationId) => {
        $.ajax({
            method: "POST",
            url: window.OPFunnelStats.rest_url,
            data: {
                fid: funnelId,
                pid: pageId,
                vid: variationId,
                referer: document.referrer,
                currentUrl: window.location.href,
                _wpnonce: window.OPFunnelStats.nonce
            }
        }).done((result) => {
            if (typeof result === 'undefined' || result.status !== 200) {
                return;
            }

            window.OPFunnelStats.queried_object_id = result.data.queried_object_id;
            window.OPFunnelStats.pageview_record_id = result.data.pageview_record_id;
        });
    }

    if (window.OPFunnelStats && window.OPFunnelStats.fid && window.OPFunnelStats.pid && window.OPFunnelStats.pid) {
        track(window.OPFunnelStats.fid, window.OPFunnelStats.pid, window.OPFunnelStats.vid);
    }
})(jQuery, window, document);